/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PoolModule
 */

import { Injectable } from '@angular/core';
import { Pool } from 'ng/modules/items/factories/pool.item.factory';

/**
 * @description Service used to provide the same instance of a Pool item across modules.
 * @author Zhiqian Liu
 */
@Injectable()
export class PoolStateService {
    /**
     * Given instance of a Pool item.
     */
    public pool: Pool;

    /**
     * The initial VS instance resolved when the pool detail page is loaded.
     */
    public initialVs: any;
}
